import { render, staticRenderFns } from "./ActionsArticle.vue?vue&type=template&id=198c39ce&"
import script from "./ActionsArticle.vue?vue&type=script&lang=js&"
export * from "./ActionsArticle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports